import { Grid, Paper, Tooltip, Typography } from '@mui/material';
import React from 'react'
import moment from 'moment'
import CardSkeleton from './CardSkeleton';
import NoDataAvailableCard from './NoDataAvailableCard';
import StatTable from './StatTable';
import NumericLabel from 'react-pretty-numbers';
import { dateMonthYearDateFormat } from '../../../constants'

const amendmentHistoryTable = [
  { field: 'date', label: 'Date', render: (row) => <span style={{ whiteSpace: 'nowrap' }}>{row?.date || '--'}</span> },
  { field: 'reference', label: 'Reference', render: (row) => row?.reference || '--' },
  {
    field: 'description',
    label: 'Description',
    render: (row) => {
      const description = row?.description || '--';
      return description.length > 40 ? (
        <Tooltip title={description} arrow placement="top">
          <span>{description.substring(0, 40)}...</span>
        </Tooltip>
      ) : description;
    },
  },
]

const actionCenterTitels = [
  { field: 'overdue_invoices', label: (count) => `overdue invoice${count === 1 ? '' : 's'}`, subtext: 'Open invoice register' },
  { field: 'insurance_renewals', label: (count) => `insurance renewal${count === 1 ? '' : 's'}`, subtext: 'Open policy' },
  { field: 'open_obligations', label: () => 'obligations due', subtext: 'Open obligations' },
  { field: 'open_exceptions', label: (count) => `redelivery exception${count === 1 ? '' : 's'}`, subtext: 'Open exception ledger' },
]

const getOpenRedeliveryExceptionsColumns = (currency) => [
  { field: 'component', label: 'Component', render: (row) => row?.component || '--' },
  {
    field: 'amount',
    label: 'Exposure',
    render: (row) => {
      const amount = Number(row?.amount)
      return row?.amount == null || Number.isNaN(amount) ? '--' : (
        <NumericLabel
          params={{
            locales: 'en-US',
            currency: true,
            currencyIndicator: currency,
            commafy: true,
            shortFormat: true,
            shortFormatMinValue: 1000,
            shortFormatPrecision: 1,
            justification: 'L',
          }}
        >
          {amount}
        </NumericLabel>
      )
    },
  },
  { field: 'significant', label: 'Significant', render: (row) => row?.significant || '--', },
]

const getUpcomingCriticalDatesColumn = [
  { field: 'event_label', label: 'Event', render: (row) => row?.event_label || '--' },
  { field: 'event_date', label: 'Due Date', render: (row) => row?.event_date ? moment(row.event_date).format(dateMonthYearDateFormat) : '--' },
  { field: 'days', label: 'Days', render: (row) => row?.days || '--' },
  { field: 'status', label: 'Status', render: (row) => row?.status || '--' },
]

const ComplainceContractEventsRedelivery = ({ data, loading = {} }) => {
  const rows = data?.amendment_history?.rows;
  const openRedeliveryData = data?.open_delivery_exceptions;
  const openRedeliveryRows = openRedeliveryData?.rows?.filter((row) => row?.component) || [];
  const openRedeliveryCurrency = openRedeliveryData?.exposure?.currency || 'USD';
  const contractActionCentre = data?.contract_action_centre;
  const upcomingCriticalDates = data?.upcoming_critical_dates?.rows;
  const contractDataComplitness = data?.contract_data_complitness?.checks;

  return (
    <div className="contract-analytics-wrapper">
      <div className="ca-page-header">
        <Typography fontSize='15px' fontFamily="Roboto-SemiBold !important">
          Compliance, Contract Events &amp; Redelivery
          <span className="ca-header-subtext"> Renewals, obligations, options, amendments and exceptions</span>
        </Typography>
      </div>
      <Grid container spacing={1.5} mx={1}>
        {/* <Grid size={{ md: 6, xs: 12}}>
          <Paper className="ca-equal-card">
            <div className="ca-card-header">
              <Typography className="ca-card-title"> Upcoming Critical Dates </Typography>
            </div>
            {loading?.upcoming_critical_dates ? (
              <CardSkeleton />
            ) : (
              <div className="ca-claim-block ca-card-body">
                {!upcomingCriticalDates?.length ? (
                  <NoDataAvailableCard title='No Upcoming Critical Dates available' subtext='Try adjusting the date range' />
                ): (
                  <div className="clm-aprv-trnard ca-scroll-table"> <StatTable columns={getUpcomingCriticalDatesColumn} rows={upcomingCriticalDates} /> </div>
                )}
              </div>
            )}
          </Paper>
        </Grid> */}
        {/* <Grid size={{ md: 6, xs: 12}}>
          <Paper className="ca-equal-card ca-side-card">
            <div className="ca-card-header"> <Typography className="ca-card-title"> Contract Data Completeness & Control Checks </Typography> </div>
            {loading?.contract_data_complitness ? (
              <CardSkeleton />
            ) : (
              <div className="ca-claim-block ca-card-body" style={{ margin: "8px 30px !important" }}>
                {!contractDataComplitness?.length ? (
                  <NoDataAvailableCard title='No completeness data available' subtext='Try adjusting the date range' />
                ) : (
                  <div className="ca-completeness-list">
                    {contractDataComplitness.map((check, index) => {
                      const percentage = Math.min(Math.max(Number(check?.percentage) || 0, 0), 100)
                      const isComplete = percentage >= 100
                      return (
                        <div className="ca-completeness-row" key={check?.label || index}>
                          <span className="ca-completeness-label">{check?.label || '--'}</span>
                          <div className="ca-completeness-bar-track">
                            <div className={`ca-completeness-bar-fill ${isComplete ? 'is-complete' : 'is-pending'}`} style={{ width: `${percentage}%` }} />
                          </div>
                          <span className="ca-completeness-status">{`${percentage}%`}</span>
                        </div>
                      )
                    })}
                  </div>
                )}
              </div>
            )}
          </Paper>
        </Grid> */}
        <Grid size={{ md: 4, xs: 12 }}>
          <Paper className="ca-equal-card">
            <div className="ca-card-header">
              <Typography className="ca-card-title"> Amendment History </Typography>
            </div>
            {loading?.amendment_history ? (
              <CardSkeleton />
            ) : (
              <div className="ca-claim-block ca-card-body">
                {!rows?.length ? (
                  <NoDataAvailableCard title='No amendment history available' subtext='Try adjusting the date range' />
                ) : (
                  <div className='clm-aprv-trnard ca-scroll-table'>
                    <StatTable columns={amendmentHistoryTable} rows={rows} />
                  </div>
                )}
              </div>
            )}
          </Paper>
        </Grid>
        {/* <Grid size={{ md: 4, xs: 12 }}>
          <Paper className="ca-equal-card">
            <div className="ca-card-header">
              <Typography className="ca-card-title">Open Redelivery Exceptions</Typography>
            </div>
            {loading?.open_delivery_exceptions ? (
              <CardSkeleton />
            ) : (
              <div className="ca-claim-block ca-card-body">
                {!openRedeliveryRows.length ? (
                  <NoDataAvailableCard title='No open redelivery exceptions' subtext='Try adjusting the date range' />
                ) : (
                  <>
                    <div className="ca-card-heigh-lights">
                      <div>
                        <Typography variant="h1" className='ca-heigh-lights'>{openRedeliveryData?.open_exceptions_count ?? 0}</Typography>
                        <span className="ca-heigh-lights-subtext">Open exceptions</span>
                      </div>
                      <div>
                        <Typography variant="h1" className='ca-heigh-lights'>
                          {Number.isNaN(Number(openRedeliveryData?.exposure?.amount)) ? '--' : (
                            <NumericLabel
                              params={{
                                locales: 'en-US',
                                currency: true,
                                currencyIndicator: openRedeliveryCurrency,
                                commafy: true,
                                shortFormat: true,
                                shortFormatMinValue: 1000,
                                shortFormatPrecision: 1,
                                justification: 'L',
                              }}
                            >
                              {Number(openRedeliveryData?.exposure?.amount) || 0}
                            </NumericLabel>
                          )}
                        </Typography>
                        <span className="ca-heigh-lights-subtext">Exposure</span>
                      </div>
                    </div>
                    <div className="ca-scroll-table">
                      <StatTable columns={getOpenRedeliveryExceptionsColumns(openRedeliveryCurrency)} rows={openRedeliveryRows} />
                    </div>
                  </>
                )}
              </div>
            )}
          </Paper>
        </Grid> */}
        {/* <Grid size={{ md: 4, xs: 12 }}>
          <Paper className="ca-equal-card ca-side-card">
            <div className="ca-card-header">
              <Typography className="ca-card-title">Contract Action Centre</Typography>
            </div>
            {loading?.contract_action_centre ? (
              <CardSkeleton />
            ) : (
              <>
                <div className="ca-claim-block ca-card-body ca-action-centre-body">
                  <div className="ca-action-centre-grid">
                    {actionCenterTitels.map((tile) => {
                      const count = contractActionCentre?.[tile.field] ?? 0
                      return (
                        <div className="ca-action-tile" key={tile.field}>
                          <Typography className="ca-action-tile-count">
                            {count} {tile.label(count)}
                          </Typography>
                          <Typography className="ca-action-tile-subtext">{tile.subtext}</Typography>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </>
            )}
          </Paper>
        </Grid> */}
      </Grid>
    </div>
  )
}

export default ComplainceContractEventsRedelivery